module.exports = __webpack_public_path__ + "static/media/arrow-up.055c186c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-up.svg
// module id = 2375
// module chunks = 0